module.exports = __webpack_public_path__ + "static/006729-e49201474e1edf2d97b04fe85ead2dcf.jpg";